import styled from 'styled-components';
import { fixedHeightKeys, fixedHeightMixin, fontSpacingKeys, fontSpacingMixin } from '../mixins/typography';
import { withOmitProps } from '../helpers/elements';
import { H2 as H2Size } from './constants/h2.size';
import { H2 as H2Spacing } from './constants/h2.spacing';
import { largeHeadingStyle } from './style/large-heading';
import { baseTypographyStyle } from './style/base';
import { baseTypographyKeys, baseTypographyMixin } from './mixins/base';
import { lineHeight } from '../style/line-height';
import { fontSize } from '../style/font-size';
const H2 = styled.h2.withConfig(withOmitProps([...fontSpacingKeys, ...fixedHeightKeys, ...baseTypographyKeys]))`
  ${baseTypographyStyle}
  ${baseTypographyMixin}
  ${largeHeadingStyle}
  ${fontSpacingMixin(H2Spacing)}
  ${fontSize(H2Size.fontSize)}
  ${lineHeight(H2Size.lineHeight)}
  ${fixedHeightMixin(H2Size.lineHeight)}
`;

// @ts-expect-error Assigning type to never
H2._size = H2Size;
export default H2;